import React from 'react'

import { useSearchContext } from '../../../Context/SearchContext'
import ResultsIframe from '../Google/ResultsIframe.js'

const WikipediaResultsIframe = ({ kbLangKey, q }) => {
    const [searchState] = useSearchContext()

    return (
        <div className='WikipediaResults'>
            <style jsx global>
                {`
                    .WikipediaResults .SearchResults.show {
                        height: 3000px;
                        display: block;
                        border: 2px solid white;
                        border-radius: 10px;
                        margin-top: 13px !important;
                    }
                    .WikipediaResults .SearchResults.show iframe {
                        overflow: scroll;
                        width: 100%;
                        height: 100%;
                    }
                    .WikipediaResults .SearchResults.show.desktop {
                        height: 85vh;
                        margin: 0 auto;
                    }
                    @media (max-width: 867px) {
                        .WikipediaResults .SearchResults.show {
                            margin: 0 8px;
                        }
                    }
                    @media (max-width: 720px) {
                        .WikipediaResults .SearchResults.show {
                            width: 100%;
                            margin: 0;
                        }
                    }
                `}
            </style>
            <ResultsIframe
                kbLangKey={kbLangKey}
                showResults={searchState.showResults}
                src={`https://${kbLangKey}.m.wikipedia.org/wiki/${q}`}
                q={q}
                key={q}
                title='Wikipedia Entry'
            />
        </div>
    )
}

export default WikipediaResultsIframe
